<!--  -->
<template>
<div class='container'>
    <div class="top">
        <i class="iconfont icon-sousuo1"></i>
        <input type="text" v-model="company_name" placeholder="查找企业">
    </div>
    <!-- <div class="item" v-for="(item,i) in companyList" :key="i">
        <span class="company">{{item.company_name}}</span>
        <button @click="applyBind(item.id)">申请绑定</button>
    </div> -->
    <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        >
        <div class="item" v-for="(item,i) in companyList" :key="i">
        <span class="company">{{item.company_name}}</span>
        <button @click="applyBind(item.id)">申请绑定</button>
    </div>
    </van-list>
    <!-- <div class="item">
        <span class="company">广东亦强科技有限公司</span>
        <button>申请绑定</button>
    </div>
    <div class="item">
        <span class="company">广东亦强科技有限公司</span>
        <button>申请绑定</button>
    </div>
    <div class="item">
        <span class="company">广东亦强科技有限公司</span>
        <button>申请绑定</button>
    </div> -->
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    page:1,
    per_page:10,
    companyList:[],
    company_name:"",

    list: [],
    loading: false,
    finished: false,
    total:null
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
    company_name(name){
        this.getCompanyList(name)
    }
},
//方法集合
methods: {
    // 获取企业列表 --- 个人
    getCompanyList(name){
        // this.$store.commit("showLoading")
        this.$http.getCompanyList({
            page:this.page,
            per_page:this.per_page,
            company_name:name
        }).then(res=>{
            // this.$store.commit("hideLoading")
            if(res.status == 1){
                this.companyList = res.data.data
            }
        })
    },
    // 申请绑定
    applyBind(id){
        this.$hide.confirm({
            message:"确定要申请绑定到该企业?"
        }).then(()=>{
            this.$http.applyBindCompany({
                company_id:id
            }).then(res=>{
                if(res.status == 1){
                    this.$toast.success(res.msg)
                }else{
                    this.$hide.alert({
                        message:res.msg
                    })
                }
            })
        })
        
    },

    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        // for (let i = 0; i < 10; i++) {
        //   this.companyList.push(this.companyList.length + 1);
        // }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.companyList.length == this.total) {
          this.finished = true;
        }
      }, 500);
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    this.$store.commit('showLoading')
    this.$http.getCompanyList({
            page:this.page,
            per_page:this.per_page,
        }).then(res=>{
            this.$store.commit('hideLoading')
            this.$store.commit("hideLoading")
            if(res.status == 1){
                this.companyList = res.data.data
                this.total = res.data.total
            }
        })
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    .top{
        width: 100%;
        height: 51px;
        background-color: #fff;
        position: relative;
        input{
            width: 90%;
            background-color: #f0f0f0;
            text-align: center;
            color: #999999;
            font-size: 14px;
            border: none;
            height: 34px;
            line-height: 34px;
            border-radius: 17px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
        .iconfont{
            position: absolute;
            top: 50%;
            left: 40%;
            transform: translate(-50%,-50%);
            z-index: 10;
            color:#999999;
        }
    }
    .item{
        margin-top: 10px;
        height: 75px;
        line-height: 75px;
        background-color: #fff;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        box-sizing: border-box;
        .company{
            font-size: 16px;
            color: #333333;
        }
        button{
            color: #fff;
            background-color: #0e88f7;
            border: none;
            width: 80px;
            height: 28px;
            border-radius: 13px;
            font-size: 13px;
            text-align: center;
            // line-height: 80px;
            line-height: 28px;
        }
    }
}
</style>